import { SearchApiResult } from '../../services/api'
import { ComboBoxItem, ComboBoxItemProps } from '../combo-box'
import { Highlight } from '../highlight'
import { getRedirectForTicker } from './util'

interface SearchItemProps extends Pick<ComboBoxItemProps, 'state'> {
  item: SearchApiResult
}

export function SearchItem(props: SearchItemProps) {
  return (
    <ComboBoxItem
      as="a"
      href={getRedirectForTicker(props.item.ticker)}
      state={props.state}
      value={props.item.ticker}
      className="w-full shrink-0 appearance-none"
      contentClass="flex overflow-hidden px-1 -mx-1"
    >
      <span className="w-20">
        <Highlight text={props.item.ticker} highlight={props.state!.inputValue} />
      </span>
      <span className="-mx-1 flex-1 truncate px-1">
        <Highlight text={props.item.company} highlight={props.state!.inputValue} />
      </span>
      <span className="ml-2 uppercase text-gray-600">{props.item.exchange}</span>
    </ComboBoxItem>
  )
}
